import Form, { InputType } from '../../lib/Formik';
import { OtpField, ResendOtp, useTimer } from '../../lib/OtpField';
import en from '../../lang/en-us';
import { FormikHelpers, useFormik } from 'formik';
import { connect } from 'react-redux';
import { onResendLoginOTP as resendOtp, verifyOtp } from '../../redux-store/actions/login';
import { VerifyOtpPayload } from '../../redux-store/types/login';
import { useEffect, useMemo } from 'react';
import { useState } from 'react';
import { addDialCode, OTP_ACTIONS } from '../../utils/constants';

const { signupOtp, forgotPassword, common } = en;

const initOTPInfo = {
    reqId: '',
    otpRef: '',
};

const formFields: Partial<InputType>[] = [
    {
        component: OtpField,
        name: 'otp',
    },
];

const initialValues = {
    otp: new Array(6).fill(''),
};

function SignUpOtp(props: any) {
    const { mobile = '', email = '', ...rest } = props.location.state || {};
    const { timer, resetTimer, startTimer } = useTimer({});
    const [otpInfo, setOtpInfo] = useState<{ reqId: string; otpRef: string }>(initOTPInfo);

    const onVerify = async (
        values: { otp: string[] },
        action: FormikHelpers<{ otp: string[] }>,
    ) => {
        if (values.otp.join('').length !== 6) {
            action.setSubmitting(false);
            alert(common.noOtp);
            return;
        }
        const payload: any = {
            ...otpInfo,
            enteredOtp: values.otp.join(''),
            mobile: mobile && addDialCode(mobile),
            email,
            pan: rest.pan,
            pekrn: rest.pekrn,
            action: OTP_ACTIONS.register,
        };
        try {
            await props.verifyOtp(payload);
            props.history.push(`set-password`, { ...rest, ...otpInfo });
        } catch (err: any) {
            alert(err.message);
        }
        action.setSubmitting(false);
    };

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit: onVerify,
    });

    useEffect(() => {
        // if (!mobile || !email) {
        //     props.history.push('signin');
        //     return;
        // }
        setOtpInfo({ otpRef: rest.otpRef, reqId: rest.reqId });
    }, []);

    const onResend = async () => {
        try {
            let res = await props.resendOtp({
                otpRef: rest.otpRef,
                reqId: rest.reqId,
                action: OTP_ACTIONS.register,
            });
            resetTimer();
            setOtpInfo({ ...(res || {}).body });
            formik.setValues({ otp: new Array(6).fill('') });
        } catch (err: any) {
            alert(err.message);
        }
    };
    const _Form = useMemo(() => {
        return <Form ui={formFields} formik={formik} submitButtonLabel="Verify OTP"></Form>;
    }, [formik]);
    return (
        <div className="signup-padding">
            <div className="signup-progress">
                <span className="active"></span>
                <span></span>
                <span></span>
            </div>
            <h3 className="text-center">{signupOtp.heading}</h3>
            <p className="otp-sent-info text-center subheading">
                {forgotPassword.otpinfo}{' '}
                <span>
                    {mobile ? `*****${mobile.slice(6, 10)}` : `*****@${email.split('@')[1]}`}
                </span>
            </p>
            {_Form}
            <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
        </div>
    );
}

export default connect(null, { verifyOtp, resendOtp })(SignUpOtp);
